import { Typography, Button, Grid } from '@mui/material'
import DataTable from 'components/DataTable/DataTable'
import { IHeader } from 'components/DataTable/IHeader'
import { isNil } from 'lodash-es'
import { GiftCardSlimContract } from 'models'
import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormat } from 'Services/localize/format'
import nameof from 'utilities/nameof'
import SearchTextField from './SearchTextField'
interface giftcardTableData {
    cardId: string
    cardCode: string
    customerName: string
    expiryDate: string
    initvalue: string
    currentBalance: string
    giftCardTypeName: string
}
const column = nameof<giftcardTableData>()

interface IProps {
    onView: (code: string) => void
    onSelect: (id: string) => void
    giftCards: GiftCardSlimContract[]
    loading: boolean
}
function GiftCardLookup({
    onView,
    onSelect,
    giftCards: giftcards = [],
    loading,
}: IProps) {
    const { t } = useTranslation()
    const [giftCardSearchText, setGiftCardCode] = useState('')
    const { shortDateFormat, currency } = useFormat()
    const filterGiftCards: giftcardTableData[] = useMemo(() => {
        const text = giftCardSearchText.toLowerCase()
        return giftcards
            .filter((a) => !a.isDisabled)
            .map((a) => {
                return {
                    cardId: a.giftCardID!,
                    cardCode: a.issueNo,
                    customerName: a.customerOwnerGivenName || '-',
                    expiryDate: shortDateFormat(a.expiryDate!) || '-',
                    initvalue: currency(a.initialValue ?? 0, a.currencyCode!),
                    currentBalance: currency(
                        a.currentBalance ?? 0,
                        a.currencyCode!,
                    ),
                    giftCardTypeName: a.giftCardTypeName || '',
                } as giftcardTableData
            })
            .filter(
                (a) =>
                    a.cardCode.toLowerCase().includes(text) ||
                    a.customerName.toLowerCase().includes(text) ||
                    a.giftCardTypeName.toLowerCase().includes(text),
            )
    }, [giftCardSearchText, giftcards, currency, shortDateFormat])

    const headers: IHeader[] = [
        {
            label: t('payment.label.card_code'),
            value: column.cardCode,
        },
        {
            label: t('payment.label.card_name'),
            value: column.giftCardTypeName,
        },
        {
            label: t('payment.label.customer'),
            value: column.customerName,
        },
        {
            label: t('payment.label.expire_date'),
            value: column.expiryDate,
        },
        {
            label: t('payment.label.initial_value'),
            value: column.initvalue,
        },
        {
            label: t('payment.label.balance'),
            value: column.currentBalance,
        },
    ]
    return (
        <React.Fragment>
            <Typography variant="subtitle2" fontWeight={600}>
                Enter Gift Card Code or Scan
            </Typography>
            <Grid container spacing={2} py={2}>
                <Grid item md={7} xs={12}>
                    <SearchTextField
                        fullWidth
                        value={giftCardSearchText}
                        onChange={(e) => setGiftCardCode(e.target.value)}
                        placeholder="Enter Customer Name, Gift Card Name or Gift Card Code"
                    />
                </Grid>
                <Grid item md={7} xs={12}>
                    <Button
                        disabled={
                            isNil(giftCardSearchText) ||
                            giftCardSearchText.length === 0
                        }
                        color="primary"
                        size="large"
                        fullWidth
                        // sx={{ width: isMobile ? '100%' : '60%', height: 60 }}
                        className="textUpper"
                        onClick={() => onView(giftCardSearchText)}
                    >
                        view
                    </Button>
                </Grid>
            </Grid>
            <DataTable
                loading={loading}
                onRowClick={(selected) => onSelect(selected.cardId)}
                selectMode={false}
                initialRowPerPage={5}
                headers={headers}
                itemKey={column.cardCode}
                data={filterGiftCards}
            />
        </React.Fragment>
    )
}

export default GiftCardLookup
